export default {
  namespaced: true,
  state: {
    // Permisos para secciones del sistema
    isBuscarBL: false,
    isPlanificacionAnual: false,
    isPlanificacionSemanal: false,
    isServicios: false,
    isBooking: false,
    isGeneral: false,
    isTarifas: false,
    isItinerarios: false,
    isTracking: false,
  },
  mutations: {
    setIsBuscarBL(state, payload) {
      state.isBuscarBL = payload;
    },
    setIsPlanificacionAnual(state, payload) {
      state.isPlanificacionAnual = payload;
    },
    setIsPlanificacionSemanal(state, payload) {
      state.isPlanificacionSemanal = payload;
    },
    setIsServicios(state, payload) {
      state.isServicios = payload;
    },
    setIsBooking(state, payload) {
      state.isBooking = payload;
    },
    setIsGeneral(state, payload) {
      state.isGeneral = payload;
    },
    setIsTarifas(state, payload) {
      state.isTarifas = payload;
    },
    setIsItinerarios(state, payload) {
      state.isItinerarios = payload;
    },
    setIsTracking(state, payload) {
      state.isTracking = payload;
    },

    //
  },
  actions: {
    AccionCambiarIsBuscarBL({ commit }, data) {
      commit("setIsBuscarBL", data);
    },
    AccionCambiarIsPlanificacionAnual({ commit }, data) {
      commit("setIsPlanificacionAnual", data);
    },
    AccionCambiarIsPlanificacionSemanal({ commit }, data) {
      commit("setIsPlanificacionSemanal", data);
    },
    AccionCambiarIsServicios({ commit }, data) {
      commit("setIsServicios", data);
    },
    AccionCambiarIsBooking({ commit }, data) {
      commit("setIsBooking", data);
    },
    AccionCambiarIsGeneral({ commit }, data) {
      commit("setIsGeneral", data);
    },
    AccionCambiarIsTarifas({ commit }, data) {
      commit("setIsTarifas", data);
    },
    AccionCambiarIsItinerarios({ commit }, data) {
      commit("setIsItinerarios", data);
    },
    AccionCambiarIsTracking({ commit }, data) {
      commit("setIsTracking", data);
    },
  },
};
